<template>
  <div :class="['exam-detail-container', { 'forbid-copy': forbidCopyEnabled }]" @copy="handleCopy" @cut="handleCopy" @contextmenu="handleContextMenu">
    <div class="exam-detail" @copy="handleCopy" @cut="handleCopy">
      <div class="exam-header">
        <div class="logo">
          <img src="@/assets/new_picture/LOGO_b.png" alt="Logo" class="logo-img">
        </div>
        <div class="exam-title">{{ examTitle || '加载中...' }}</div>
        <div v-if="!isFormalExam" class="exit-exam" @click="exitExam">退出考试</div>
      </div>
      
      <div class="exam-nav">
        <el-breadcrumb separator="/"></el-breadcrumb>
      </div>
      
      <div class="exam-content">
        <div class="left-panel">
          <div v-if="!isUnlimitedTime" class="time-info">
            <div class="time-icon"><i class="el-icon-time"></i></div>
            <div class="time-label">剩余时间</div>
            <div class="time-display">{{ formattedTime }}</div>
          </div>
          
          <div class="answer-card">
            <div class="card-title">答题卡</div>
            <div class="question-numbers">
              <div 
                v-for="(q, index) in questions" 
                :key="q.id" 
                class="question-number"
                :class="getQuestionStatus(q.id)"
                @click="scrollToQuestion(index)"
              >
                {{ index + 1 }}
              </div>
            </div>
            
            <div class="divider"></div>

            <div class="card-footer">
              <div class="status-info">
                <div class="status-item">
                  <div class="status-box answered"></div>
                  <span>已答</span>
                </div>
                <div class="status-item">
                  <div class="status-box unanswered"></div>
                  <span>未答</span>
                </div>
              </div>
              <el-button type="primary" class="submit-btn" @click="submitAnswers(false)">提交并查看结果</el-button>
            </div>
          </div>
        </div>
        
        <div class="right-panel">
          <div v-for="(question, index) in questions" :key="question.id" class="question-item" :ref="'question_' + index">
            <div class="question-header">
              <div class="question-number">{{ index + 1 }}.</div>
              <div class="question-title">
                {{ question.title }}
                <span class="question-type">
                  ({{
                    question.type === 'single'
                      ? '单选'
                      : question.type === 'multiple'
                          ? '多选'
                          : '问答'
                  }})
                </span>
              </div>
            </div>
            <div class="question-options">
              <div v-if="question.type === 'shortAnswer'" class="short-answer">
                <el-input
                  type="textarea"
                  :rows="4"
                  :value="answers[question.id]"
                  placeholder="请输入答案"
                  @input="setShortAnswer(question.id, $event)"
                />
              </div>
              <template v-else>
                <div
                  v-for="option in question.options"
                  :key="option.id"
                  class="option-item"
                  :class="{
                    selected:
                      question.type === 'single'
                        ? Number(answers[question.id]) === Number(option.id)
                        : Array.isArray(answers[question.id]) && answers[question.id].map(Number).includes(Number(option.id))
                  }"
                >
                  <button class="option-circle" @click="selectOption(question.id, option.id, question.type)">
                    {{ option.letter }}
                  </button>
                  <div class="option-text">{{ option.content }}</div>
                </div>
              </template>
        </div>
          </div>
        </div>
      </div>
      
      
    </div>
    
    <!-- 结果弹窗 -->
    <el-dialog
      title="考试结果"
      :visible.sync="showResultDialog"
      width="500px"
      center
      :show-close="false"
      :close-on-click-modal="false"
    >
      <div class="result-content">
        <div class="result-score">
          <div class="score-circle">
            <div class="score-value">{{ calculateCorrectRate() }}%</div>
          </div>
        </div>
        <div class="result-stats">
          <div class="stat-item">
            <span class="stat-label">题目数：</span>
            <span class="stat-value">{{ questions.length }}题</span>
          </div>
          <div class="stat-item">
            <span class="stat-label">正确数：</span>
            <span class="stat-value">{{ questions.length - calculateWrongCount() - calculateUnansweredCount() }}题</span>
          </div>
          <div class="stat-item">
            <span class="stat-label">错误数：</span>
            <span class="stat-value">{{ calculateWrongCount() }}题</span>
          </div>
          <div class="stat-item">
            <span class="stat-label">未答数：</span>
            <span class="stat-value">{{ calculateUnansweredCount() }}题</span>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="retryPractice">再次答题</el-button>
        <el-button @click="backToMyCourses">返回我的练习</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getFrontendExamPaper, getMyExamList, getPaperPractice, submitFrontendExam } from '@/api/examApi'

export default {
  name: 'ExamDetail',
  data() {
    return {
      examTitle: '',
      remainingTime: 0, // 剩余时间（秒）
      totalDuration: 0, // 总时长（秒）
      startTime: 0, // 开始时间戳
      timer: null, // 计时器
      answers: {}, // 存储用户答案
      showResultDialog: false, // 控制结果弹窗显示
      questions: [],
      paperId: null,
      paperSessionId: null,
      examId: null,
      isFormalExam: false,
      showScore: 1,
      judgeType: 1,
      answerDurationMinutes: null,
      paperType: null,
      isUnlimitedTime: false,
      totalScore: 0,
      passScore: 0,
      forbidCopy: 0,
      pageLeaveLimit: 0,
      enableFaceRecognition: 0,
      faceExempt: 0,
      pageLeaveCount: 0,
      pendingForceSubmit: false,
      screenSwitchDialogVisible: false
    }
  },
  computed: {
    forbidCopyEnabled() {
      return Number(this.forbidCopy) === 1
    },
    formattedTime() {
      if (this.isUnlimitedTime) return '不限时'
      const hours = Math.floor(this.remainingTime / 3600)
      const minutes = Math.floor((this.remainingTime % 3600) / 60)
      const seconds = this.remainingTime % 60
      return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`
    }
  },
  async created() {
    this.paperId = this.$route.params.id
    if (!this.paperId) return
    await this.loadExamRuleFromMyList()
    if (this.redirectToIntroIfFaceRequired()) return
    this.fetchPaper()
  },
  mounted() {
    // 添加页面可见性变化监听器，用于检测切屏
    this.visibilityChangeHandler = () => {
      if (document.hidden) {
        this.pageLeaveCount += 1
        const limit = Number(this.pageLeaveLimit || 0)
        if (Number.isFinite(limit) && limit > 0 && this.pageLeaveCount >= limit) {
          this.pendingForceSubmit = true
        }
        return
      }

      if (this.pendingForceSubmit) {
        this.pendingForceSubmit = false
        if (this.timer) clearInterval(this.timer)
        this.submitAnswers(true)
        return
      }

      if (this.pageLeaveCount > 0) {
        this.showScreenSwitchWarning(false)
      }
    }
    
    // 监听页面可见性变化事件
    document.addEventListener('visibilitychange', this.visibilityChangeHandler)
  },
  methods: {
    async loadExamRuleFromMyList() {
      const id = this.paperId
      if (!id) return
      try {
        const pageSize = 50
        let pageNum = 1
        let found = null

        while (pageNum <= 20 && !found) {
          const res = await getMyExamList({ pageNum, pageSize })
          const data = res && res.data ? res.data : {}
          const list = Array.isArray(data.list) ? data.list : []
          found = list.find(it => String(it && it.id) === String(id)) || null
          const total = Number(data.total || 0)
          if (!total) break
          if (pageNum * pageSize >= total) break
          pageNum += 1
        }

        if (found) {
          this.forbidCopy = Number(found.forbidCopy ?? found.forbid_copy ?? 0)
          this.pageLeaveLimit = Number(found.pageLeaveLimit ?? found.page_leave_limit ?? 0)
          this.enableFaceRecognition = Number(found.enableFaceRecognition ?? found.enable_face_recognition ?? 0)
          this.faceExempt = Number(found.faceExempt ?? 0)
          const d = Number(found.answerDuration ?? found.answer_duration)
          this.answerDurationMinutes = Number.isFinite(d) && d > 0 ? d : this.answerDurationMinutes
        }
      } catch (e) {
        void e
      }
    },
    redirectToIntroIfFaceRequired() {
      if (Number(this.enableFaceRecognition) !== 1) return false
      if (Number(this.faceExempt) === 1) return false
      const passed = sessionStorage.getItem(`exam_face_passed_${this.paperId}`)
      if (passed) return false

      const returnPath = (this.$route && this.$route.fullPath) || ''
      const query = { ...(this.$route && this.$route.query ? this.$route.query : {}) }
      if (!query.returnPath && returnPath) query.returnPath = returnPath
      this.$router.replace({ name: 'examIntro', params: { id: this.paperId }, query })
      return true
    },
    // 显示切屏警示弹框
    showScreenSwitchWarning(isForceSubmit) {
      if (this.screenSwitchDialogVisible) return
      this.screenSwitchDialogVisible = true

      const limit = Number(this.pageLeaveLimit || 0)
      const limitText =
        Number.isFinite(limit) && limit > 0
          ? `（已切屏 ${this.pageLeaveCount} 次 / 最多 ${limit} 次）`
          : `（已切屏 ${this.pageLeaveCount} 次）`
      const title = '警示'
      const message = isForceSubmit
        ? `已超过切屏次数限制${limitText}，系统将自动交卷。`
        : `考试期间请勿切换标签页或窗口${limitText}。`

      this.$alert(message, title, {
        type: 'warning',
        confirmButtonText: '我知道了',
        closeOnClickModal: false,
        closeOnPressEscape: false
      })
        .then(() => {
          if (isForceSubmit) {
            this.submitAnswers(true)
          }
        })
        .catch(() => {
          void 0
        })
        .finally(() => {
          this.screenSwitchDialogVisible = false
        })
    },
    
    selectOption(questionId, optionId, type) {
      if (type === 'single') {
        // 单选题直接赋值
        this.$set(this.answers, questionId, optionId)
      } else {
        // 多选题处理逻辑
        const current = Array.isArray(this.answers[questionId]) ? this.answers[questionId] : []
        const index = current.indexOf(optionId)
        if (index > -1) {
          // 已选中则移除
          current.splice(index, 1)
        } else {
          // 未选中则添加
          current.push(optionId)
        }
        this.$set(this.answers, questionId, current)
      }
    },
    setShortAnswer(questionId, value) {
      this.$set(this.answers, questionId, value)
    },
    // 提交答案并查看结果
    async submitAnswers(isForce = false) {
      // 非强制交卷时，弹出二次确认
      if (!isForce) {
        try {
          const unansweredCount = this.questions.filter(q => {
            const ans = this.answers[q.id]
            return ans == null || (Array.isArray(ans) && ans.length === 0) || (q.type === 'shortAnswer' && !String(ans || '').trim())
          }).length
          const message = unansweredCount > 0
            ? `还有 ${unansweredCount} 题未作答，确定要交卷吗？交卷后将无法修改答案。`
            : '确定要交卷吗？交卷后将无法修改答案。'
          await this.$confirm(message, '确认交卷', {
            confirmButtonText: '确定交卷',
            cancelButtonText: '继续答题',
            type: 'warning'
          })
        } catch (e) {
          return
        }
      }

      // 停止计时器
      if (this.timer) clearInterval(this.timer)

      const duration = Math.floor((Date.now() - this.startTime) / 1000)

      const formattedAnswers = {}
      let unansweredCount = 0
      this.questions.forEach(q => {
        const ans = this.answers[q.id]
        const isUnanswered =
          ans == null ||
          (Array.isArray(ans) && ans.length === 0) ||
          (q.type === 'shortAnswer' && !String(ans || '').trim())
        if (isUnanswered) {
          unansweredCount += 1
          return
        }
        formattedAnswers[q.id] = q.type === 'shortAnswer' ? String(ans || '').trim() : ans
      })

      const totalCount = this.questions.length
      const totalScore = this.totalScore || 100
      const passScore = this.passScore || 60
      
      const payload = {
        answers: formattedAnswers,
        duration: duration > 0 ? duration : 0,
        paperId: Number(this.paperId),
        paperSessionId: this.paperSessionId,
        startTime: this.startTime,
        isForceSubmit: isForce ? 1 : 0
      }
      
      if (this.examId) {
        payload.examId = Number(this.examId)
      }
      
      try {
        const res = await submitFrontendExam(payload)
        if (res.code !== 200) {
          this.$message.error(res.message || '提交失败')
          this.startTimer()
          return
        }

        const data = (res && res.data) || {}
        const actualScore = Number(data.actualScore ?? data.userScore ?? data.score ?? data.paperScore ?? 0)
        const normalizePassed = val => val === true || val === 1 || val === '1' || val === 'true'
        const passedFromApi =
          data.isPassed != null ? normalizePassed(data.isPassed) : actualScore >= Number(passScore || 0)
        const totalCountFromApi = Number(data.totalCount ?? data.total ?? data.totalNum ?? totalCount) || totalCount
        const wrongCountFromApi = Number(data.wrongCount ?? data.wrongNum ?? data.wrong ?? 0)
        const correctCountFromApi = Number(data.correctCount ?? data.correctNum ?? data.correct ?? 0)
        
        const wrongCount = wrongCountFromApi > 0 
          ? wrongCountFromApi 
          : (correctCountFromApi > 0 
            ? Math.max(0, totalCountFromApi - correctCountFromApi - unansweredCount) 
            : 0)
        
        const correctCount = correctCountFromApi > 0 
          ? correctCountFromApi 
          : Math.max(0, totalCountFromApi - wrongCount - unansweredCount)
        const totalScoreFromApi = Number(data.totalScore ?? totalScore) || totalScore
        const durationFromApi = Number(data.duration ?? duration) || 0

        const questionById = this.questions.reduce((acc, q) => {
          acc[String(q.id)] = q
          return acc
        }, {})

        const mapAnswerToText = (qid, rawAnswer) => {
          const q = questionById[String(qid)] || null
          const normalizeArray = (v) => {
            if (Array.isArray(v)) return v
            if (typeof v === 'string') {
              const s = v.trim()
              if (!s) return []
              return s.split(/[,\s、]+/).filter(Boolean)
            }
            if (v == null) return []
            return [v]
          }

          if (!q || q.type === 'shortAnswer') {
            if (Array.isArray(rawAnswer)) return rawAnswer.join('、')
            return String(rawAnswer ?? '').trim()
          }

          const options = Array.isArray(q.options) ? q.options : []
          const arr = normalizeArray(rawAnswer)
          if (!arr.length) return ''

          const mapped = arr
            .map(v => {
              const vs = String(v).trim()
              if (!vs) return ''
              if (/^[A-Z]$/.test(vs)) return vs
              const opt = options.find(o => String(o.id) === vs)
              return opt ? String(opt.letter || '').trim() : vs
            })
            .filter(Boolean)

          return mapped.join('、')
        }

        const scoreListRaw = data.questionScores || data.question_scores || []
        const scoreList = Array.isArray(scoreListRaw) ? scoreListRaw : []
        const resultListRaw = data.results || data.questionResults || data.questionResultList || data.detailList || []
        const resultList = Array.isArray(resultListRaw) ? resultListRaw : []

        const buildDetail = (item) => {
          const qid = item.questionId ?? item.id ?? item.question_id ?? item.questionID
          const id = qid != null ? Number(qid) : undefined
          const isCorrectRaw = item.isCorrect ?? item.correct ?? item.right ?? item.is_right
          const isCorrect =
            typeof isCorrectRaw === 'boolean'
              ? isCorrectRaw
              : isCorrectRaw == null
                ? false
                : Number(isCorrectRaw) === 1
          const q = id != null ? questionById[String(id)] : null
          const content = (item.content ?? item.questionContent ?? item.title) || (q && q.title) || ''
          const userAnswerRaw =
            item.userAnswer ??
            item.user_answer ??
            item.answer ??
            item.userContent ??
            item.userText ??
            item.userOptionIds ??
            item.user_option_ids ??
            item.selectedOptionIds ??
            item.selected_option_ids ??
            (id != null ? formattedAnswers[id] : '')
          const userAnswer = mapAnswerToText(id, userAnswerRaw)
          const correctAnswerRaw = item.correctAnswer ?? item.correct_answer ?? item.rightAnswer ?? item.keywords ?? ''
          const correctAnswer = Array.isArray(correctAnswerRaw)
            ? correctAnswerRaw.join('、')
            : String(correctAnswerRaw ?? '')
          return {
            id: id != null ? id : undefined,
            content: String(content || '').trim(),
            isCorrect,
            userAnswer: String(userAnswer || '').trim(),
            correctAnswer: this.isFormalExam ? '' : String(correctAnswer || '').trim()
          }
        }

        const detailedResults =
          resultList.length > 0
            ? resultList.map(buildDetail).filter(r => r && r.id != null)
            : (scoreList.length > 0
                ? scoreList
                    .map(item => {
                      const normalized = {
                        questionId: item.questionId ?? item.question_id ?? item.id,
                        isCorrect: item.isCorrect ?? item.correct ?? item.right ?? item.is_right,
                        userAnswer: item.userAnswer ?? item.user_answer ?? item.answer ?? item.userContent ?? item.userText ?? item.userOptionIds ?? item.user_option_ids
                      }
                      return buildDetail(normalized)
                    })
                    .filter(r => r && r.id != null)
                : [])

        // 清除本地存储的开始时间
        const examId = this.$route.params.id
        const storageKey = `exam_start_time_${examId}`
        localStorage.removeItem(storageKey)

        // 正式考试（paperType=4）统一跳转提交成功页面，不展示成绩
        if (this.paperType === 4) {
          this.$router.push({ name: 'examSubmitSuccess' })
          return
        }
        
        // 非正式考试：根据 showScore 和 judgeType 判断跳转页面
        if (this.showScore === 0 || this.judgeType !== 1) {
          this.$router.push({ name: 'examSubmitSuccess' })
          return
        }

        this.$router.push({
          name: 'examSubmitResult',
          query: {
            source: 'exam',
            mode: (this.$route && this.$route.query && this.$route.query.mode) || '',
            hideCorrectAnswer: '',
            paperId: this.paperId,
            paperType: this.paperType,
            showScore: this.showScore,
            title: this.examTitle || '',
            examRecordId: data.examRecordId ?? data.exam_record_id ?? '',
            actualScore,
            isPassed: passedFromApi,
            correctCount: correctCount,
            total: totalCountFromApi,
            totalScore: totalScoreFromApi,
            passScore: passScore,
            duration: durationFromApi,
            wrong: wrongCount,
            unanswered: unansweredCount,
            results: detailedResults.length ? JSON.stringify(detailedResults) : '',
            returnPath: this.$route.query.returnPath
          }
        })
      } catch (err) {
        console.error('提交考试失败', err)
        this.$message.error('提交考试失败')
        // 恢复计时器
        this.startTimer()
      }
    },
    // 计算正确率
    calculateCorrectRate() {
      if (this.questions.length === 0) return 0
      
      let correctCount = 0
      this.questions.forEach(() => {
        if (this.isAnswerCorrect()) {
          correctCount++
        }
      })
      
      return Math.round((correctCount / this.questions.length) * 100)
    },
    // 计算错题数（正式考试暂不区分对错，这里返回 0）
    calculateWrongCount() {
      return 0
    },
    
    // 处理复制操作
    handleCopy(event) {
      if (!this.forbidCopyEnabled) return
      if (event && event.preventDefault) event.preventDefault()
      this.$message.warning('试题内容禁止复制')
    },
    
    // 处理右键菜单
    handleContextMenu(event) {
      if (!this.forbidCopyEnabled) return
      if (event && event.preventDefault) event.preventDefault()
      this.$message.warning('试题内容禁止复制')
    },
    // 滚动到指定题目
    scrollToQuestion(index) {
      const el = this.$refs['question_' + index]
      if (el && el[0]) {
        el[0].scrollIntoView({ behavior: 'smooth', block: 'center' })
      }
    },
    // 计算未答数
    calculateUnansweredCount() {
      let unansweredCount = 0
      this.questions.forEach(question => {
        if (this.getQuestionStatus(question.id) === 'unanswered') {
          unansweredCount++
        }
      })
      return unansweredCount
    },
    // 检查答案是否正确（正式考试不展示对错，恒为 false）
    isAnswerCorrect() {
      return false
    },
    // 获取题目状态
    getQuestionStatus(questionId) {
      // 检查问题是否已作答
      const answer = this.answers[questionId]
      if (
        answer == null ||
        (Array.isArray(answer) && answer.length === 0) ||
        (!Array.isArray(answer) && typeof answer === 'string' && !String(answer || '').trim())
      ) {
        return 'unanswered'
      }
      return 'answered'
    },
    // 再次答题
    retryPractice() {
      this.answers = {}
      this.showResultDialog = false
      // 重置剩余时间
      if (this.questions.length > 0) {
        // 需要重新获取或重置
        this.fetchPaper()
      }
    },
    // 返回我的练习
    backToMyCourses() {
      const returnPath = this.$route.query.returnPath
      if (returnPath) {
        this.$router.push(returnPath)
        return
      }
      this.$router.push('/my-courses')
    },
    // 退出考试，返回上一个页面
    exitExam() {
      if (this.isFormalExam) {
        this.$confirm('确定要退出考试吗？退出后将提交当前答案。', '提示', {
          confirmButtonText: '确定退出',
          cancelButtonText: '继续答题',
          type: 'warning'
        }).then(() => {
          this.submitAnswers()
        }).catch(() => {})
      } else {
        const returnPath = this.$route.query.returnPath
        if (returnPath) {
          this.$router.push(returnPath)
          return
        }
        this.$router.back()
      }
    },
    async fetchPaper() {
      try {
        const q = (this.$route && this.$route.query) || {}
        const forceExam = q.mode === 'exam'
        let res = null
        let isExam = false
        if (forceExam) {
          try {
            res = await getFrontendExamPaper(this.paperId)
            if (res && res.code === 200) {
              isExam = true
            }
          } catch (e) {
            res = null
          }
        } else {
          try {
            res = await getPaperPractice(this.paperId)
          } catch (e) {
            res = null
          }
        }
        if (!(res && res.code === 200 && res.data)) {
          res = await getFrontendExamPaper(this.paperId)
          if (res && res.code === 200) {
            isExam = true
          }
        }
        if (res && res.code === 200 && res.data) {
          const data = res.data
          if (isExam) {
            this.examId = this.paperId
          }
          this.isFormalExam = isExam

          if (data && typeof data === 'object') {
            const forbidCopy = data.forbidCopy ?? data.forbid_copy
            const pageLeaveLimit = data.pageLeaveLimit ?? data.page_leave_limit
            const enableFaceRecognition = data.enableFaceRecognition ?? data.enable_face_recognition
            if (forbidCopy != null) this.forbidCopy = Number(forbidCopy)
            if (pageLeaveLimit != null) this.pageLeaveLimit = Number(pageLeaveLimit)
            if (enableFaceRecognition != null) this.enableFaceRecognition = Number(enableFaceRecognition)
          }

          if (isExam && this.redirectToIntroIfFaceRequired()) return

          this.paperId = data.paperId
          this.paperSessionId = data.paperSessionId
          this.paperType = data.paperType
          this.showScore = Number(data.showScore ?? 1)
          this.judgeType = Number(data.judgeType ?? 1)
          this.isUnlimitedTime = Number(data.paperType) === 3
          this.examTitle = data.paperName
          this.totalScore = Number(data.totalScore) || 0
          this.passScore = Number(data.passScore) || 0
          
          // 获取或设置开始时间（刷新页面后保持原时间）
          const examId = this.$route.params.id
          const storageKey = `exam_start_time_${examId}`
          const storedStartTime = localStorage.getItem(storageKey)
          
          if (storedStartTime) {
            this.startTime = Number(storedStartTime)
          } else {
            this.startTime = Date.now()
            localStorage.setItem(storageKey, String(this.startTime))
          }
          
          if (this.isUnlimitedTime) {
            this.remainingTime = 0
            this.totalDuration = 0
          } else {
            const durationMinutes =
              (Number.isFinite(this.answerDurationMinutes) ? this.answerDurationMinutes : null) ??
              (Number(data.answerDuration ?? data.answer_duration ?? data.duration) || 0)
            const totalSeconds = durationMinutes * 60
            const elapsedSeconds = Math.floor((Date.now() - this.startTime) / 1000)
            this.remainingTime = Math.max(0, totalSeconds - elapsedSeconds)
            this.totalDuration = totalSeconds
            this.startTimer()
          }

          // 映射题目数据
          this.questions = (data.questions || []).map(q => ({
            id: q.id,
            title: q.questionContent,
            type: this.mapQuestionType(q.questionType),
            score: q.totalScore,
            options: (q.options || []).map(o => ({
              id: o.id,
              letter: o.label,
              content: o.content,
              isCorrect: o.isCorrect === true
            }))
          }))
        } else {
          this.$message.error((res && (res.message || res.msg)) || '获取试卷失败')
          setTimeout(() => {
            this.$router.back()
          }, 1500)
        }
      } catch (err) {
        console.error('获取试卷失败', err)
        this.$message.error((err && (err.message || err.msg)) || '获取试卷失败')
        setTimeout(() => {
          this.$router.back()
        }, 1500)
      }
    },
    startTimer() {
      if (this.isUnlimitedTime) return
      if (this.timer) clearInterval(this.timer)
      this.timer = setInterval(() => {
        if (this.remainingTime > 0) {
          this.remainingTime--
        } else {
          clearInterval(this.timer)
          this.$message.warning('考试时间已到，自动提交试卷')
          this.submitAnswers(true)
        }
      }, 1000)
    },
    mapQuestionType(type) {
      switch (Number(type)) {
        case 1:
          return 'single'
        case 2:
          return 'multiple'
        case 3:
          return 'single'
        case 4:
          return 'shortAnswer'
        default:
          return 'single'
      }
    }
  },
  beforeDestroy() {
    // 清除计时器
    if (this.timer) {
      clearInterval(this.timer)
    }
    
    // 移除页面可见性变化监听器
    if (this.visibilityChangeHandler) {
      document.removeEventListener('visibilitychange', this.visibilityChangeHandler)
    }
  }
}
</script>

<style lang="scss" scoped>
.exam-detail {
  .exam-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 40px;
    
    .logo {
      display: flex;
      align-items: center;
      
      .logo-img {
        height: 72px;
        width: auto;
      }
    }
    
    .exam-title {
      font-size: 18px;
      font-weight: 500;
      color: #000000;
      flex: 1;
      text-align: center;
    }
    
    .exit-exam {
      font-size: 16px;
      color: #3579f7;
      cursor: pointer;
      text-decoration: none;
    }
  }
  
  .exam-nav {
    padding: 10px 40px;
    background-color: #f5f7fa;
  }
  
  .exam-content {
    display: flex;
    padding: 20px 40px;
  }
  
  .left-panel {
    width: 300px;
    margin-right: 30px;
    position: sticky;
    top: 20px;
    align-self: flex-start;
  }
  
  .time-info {
    background-color: #fff;
    padding: 25px;
    border-radius: 8px;
    text-align: center;
    margin-bottom: 20px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
    
    .time-icon {
      font-size: 36px;
      color: #595959;
      margin-bottom: 10px;
    }

    .time-label {
      margin-bottom: 15px;
      font-size: 16px;
      color: #333;
      font-weight: 500;
    }
    
    .time-display {
      background-color: #3E2CCD;
      color: white;
      padding: 12px 0;
      border-radius: 6px;
      font-size: 28px;
      font-weight: 500;
      letter-spacing: 1px;
      width: 100%;
    }
  }
  
  .answer-card {
    background-color: #fff;
    padding: 25px;
    border-radius: 8px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
    
    .card-title {
      text-align: center;
      margin-bottom: 25px;
      font-weight: 500;
      font-size: 18px;
      color: #333;
    }
    
    .question-numbers {
      display: grid;
      grid-template-columns: repeat(5, 1fr);
      gap: 15px;
      margin-bottom: 30px;
      justify-items: center;
    }
    
    .question-number {
      width: 36px;
      height: 36px;
      background-color: #f5f5f5;
      border: 1px solid #e0e0e0;
      border-radius: 4px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      font-size: 14px;
      color: #666;
      transition: all 0.2s;
    }
    
    .question-number:hover {
      border-color: #3E2CCD;
      color: #3E2CCD;
    }
    
    .question-number.answered,
    .question-number.correct,
    .question-number.wrong {
      background-color: #ECEBFF;
      border-color: #3E2CCD;
      color: #3E2CCD;
    }
    
    .question-number.unanswered {
      background-color: #f5f5f5;
      border-color: #e0e0e0;
      color: #666;
    }

    .divider {
      height: 1px;
      border-top: 1px dashed #e0e0e0;
      margin-bottom: 20px;
      width: 100%;
    }
    
    .card-footer {
      .status-info {
        display: flex;
        align-items: center;
        margin-bottom: 20px;
        font-size: 14px;
        color: #666;
        gap: 20px;

        .status-item {
          display: flex;
          align-items: center;
          gap: 6px;
        }

        .status-box {
          width: 16px;
          height: 16px;
          border-radius: 2px;

          &.answered {
            background-color: #ECEBFF;
            border: 1px solid #3E2CCD;
          }

          &.unanswered {
            background-color: #f5f5f5;
            border: 1px solid #e0e0e0;
          }
        }
      }
      
      .submit-btn {
        width: 100%;
        background-color: #3E2CCD;
        border-color: #3E2CCD;
        padding: 12px 0;
        font-size: 16px;
        border-radius: 4px;
        height: 44px;
      }
      
      .submit-btn:hover {
        background-color: #3325ad;
        border-color: #3325ad;
      }
    }
  }
  
  .right-panel {
    flex: 1;
    background-color: white;
    padding: 20px;
    border-radius: 5px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  }
  
  .question-item {
    margin-bottom: 30px;
    padding-bottom: 30px;
    border-bottom: 1px dashed #e8e8e8;
    
    &:last-child {
      border-bottom: none;
    }
    
    .question-header {
      display: flex;
      margin-bottom: 25px;
      align-items: flex-start;
      
      .question-number {
        font-weight: 500;
        margin-right: 5px;
        color: #333;
        font-size: 16px;
        line-height: 1.6;
      }
      
      .question-title {
        font-size: 16px;
        color: #333;
        line-height: 1.6;
        flex: 1;
      }
      
      .question-type {
        display: inline-block;
        margin-left: 8px;
        padding: 2px 8px;
        background-color: #ECEBFF;
        color: #3E2CCD;
        border-radius: 4px;
        font-size: 12px;
        font-weight: normal;
        vertical-align: middle;
      }
    }
    
    .question-options {
      margin-left: 0;
    }
    
    .option-item {
      display: flex;
      align-items: flex-start;
      margin-bottom: 20px;
      cursor: pointer;
      
      &.disabled {
        cursor: not-allowed;
      }
    }
    
    .option-circle {
      width: 32px;
      height: 32px;
      border-radius: 50%;
      border: 1px solid #dcdfe6;
      background-color: #fff;
      color: #606266;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 16px;
      font-size: 16px;
      font-weight: 400;
      cursor: pointer;
      transition: all 0.3s;
      flex-shrink: 0;
      
      &:hover {
        border-color: #3E2CCD;
        color: #3E2CCD;
      }
    }
    
    .option-item.selected .option-circle {
      background-color: #3E2CCD;
      color: white;
      border-color: #3E2CCD;
    }
    
    .option-text {
      font-size: 16px;
      color: #333;
      line-height: 32px;
    }
    
    .option-item.selected .option-text {
      color: #333;
    }
    
    .confirm-option {
      margin-top: 25px;
      
      .el-button {
        background-color: #fff;
        border: 1px solid #dcdfe6;
        color: #606266;
        padding: 9px 20px;
        font-size: 14px;
        border-radius: 4px;
        
        &:hover {
          color: #3E2CCD;
          border-color: #c6e2ff;
          background-color: #ecf5ff;
        }
        
        &:disabled {
          color: #c0c4cc;
          cursor: not-allowed;
          background-image: none;
          background-color: #fff;
          border-color: #ebeef5;
        }
      }
    }
  }
  

  
  /* 结果弹窗样式 */
  .result-content {
    .result-score {
      display: flex;
      justify-content: center;
      margin-bottom: 30px;
      
      .score-circle {
        width: 150px;
        height: 150px;
        border-radius: 50%;
        background-color: #722ed1;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        overflow: hidden;
        
        &::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: linear-gradient(135deg, #722ed1 0%, #b35ffb 100%);
        }
        
        .score-value {
          position: relative;
          z-index: 1;
          color: white;
          font-size: 36px;
          font-weight: bold;
        }
      }
    }
    
    .result-stats {
      text-align: center;
      
      .stat-item {
        margin-bottom: 12px;
        font-size: 16px;
        
        .stat-label {
          color: #606266;
          margin-right: 8px;
        }
        
        .stat-value {
          color: #722ed1;
          font-weight: bold;
        }
      }
    }
  }
}

/* 禁止复制样式 */
.exam-detail-container.forbid-copy {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* 允许答题卡和按钮区域可以选择 */
.exam-detail-container.forbid-copy .answer-card,
.exam-detail-container.forbid-copy .option-circle,
.exam-detail-container.forbid-copy .el-button,
.exam-detail-container.forbid-copy .exit-exam {
  -webkit-user-select: auto;
  -moz-user-select: auto;
  -ms-user-select: auto;
  user-select: auto;
}

/* 禁止试题内容选择 */
.exam-detail-container.forbid-copy .question-item,
.exam-detail-container.forbid-copy .question-title,
.exam-detail-container.forbid-copy .option-text {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
</style>
